export const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status,
  drawer: state => state.drawer,
  currentUser: state => state.user
}
